import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const NewspaperIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.8 17.44C19.8 18.84 18.76 19.84 17.34 19.84H6.9C5.48 19.84 4.44 18.84 4.44 17.44V4.08H16.52V17.38C16.52 17.86 16.88 18.2 17.34 18.2C17.8 18.2 18.16 17.84 18.16 17.38V7.04H19.8V17.44ZM6.9 18.2H14.88V5.72H6.08V17.44C6.08 17.92 6.44 18.2 6.9 18.2ZM7.72 7.58H13.24V9.26H7.72V7.58ZM7.72 11.12H13.24V12.8H7.72V11.12ZM7.72 14.66H11.42V16.34H7.72V14.66Z" />
    </SvgIcon>
  );
});
